export const DeliveryStatusHeadOfficePage = () => {
    return <>DeliveryStatusHeadOfficePage</>
}